"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ha1Compute = void 0;
var md5_1 = __importDefault(require("md5"));
function ha1Compute(algorithm, user, realm, pass, nonce, cnonce) {
    var ha1 = (0, md5_1.default)("".concat(user, ":").concat(realm, ":").concat(pass));
    if (algorithm && algorithm.toLowerCase() === "md5-sess") {
        return (0, md5_1.default)("".concat(ha1, ":").concat(nonce, ":").concat(cnonce));
    }
    return ha1;
}
exports.ha1Compute = ha1Compute;
